// @mui icons
import GitHubIcon from "@mui/icons-material/GitHub";

// Material Kit 2 React components
import MKTypography from "components/MKTypography";

export default {
  brand: "",
  socials: [],
  menus: [],
  copyright: (
    <MKTypography variant="button" fontWeight="regular">
      By Gustavo Abreu{" "}
      <MKTypography
        component="a"
        href="https://github.com/gustavoabreu02"
        target="_blank"
        rel="noreferrer"
        variant="button"
        fontWeight="regular"
        sx={{ display: "inline-flex", alignItems: "center", ml: 0.5 }}
      >
        <GitHubIcon sx={{ fontSize: "1.1rem", mr: 0.3 }} />
        GitHub
      </MKTypography>
    </MKTypography>
  ),
};
